var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[(_vm.isLoadingFile)?_c('div',[_vm._v(" loading ")]):(_vm.failedToLoad)?_c('div'):_c('FileListWithPreviewGallery',{attrs:{"files":_vm.files,"read-only":"","hide-label":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }